<template>
  <div>
    <div v-if="loading" class="loader">
      <span class="fa fa-spinner fa-spin fa-4x" v-show="loading"></span>
    </div>

    <div v-show="!loading">
      <pdf
        class="pdf-container"
        ref="contractPdf"
        :src="src"
        :page="currentPage"
        @loaded="loaded"
        @num-pages="totalPages = $event">
      </pdf>

      <div v-if="totalPages > 1" class="text-center mb-3">
        <button class="btn btn-primary btn-circle btn-previous btn-sm" @click="previousPage" v-bind:disabled="currentPage <= 1">
          <i class="fa fa-chevron-left"></i>
        </button>
        <span class="mx-3">{{ $t('Contract.pageButtons') }} {{ currentPage }}/{{ totalPages }}</span>
        <button class="btn btn-primary btn-circle btn-next btn-sm" @click="nextPage" v-bind:disabled="currentPage >= totalPages">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'pdfViewer',
  props: ['src'],
  data: function() {
    return {
      totalPages: 0,
      currentPage: 1,
      loading: true
    }
  },
  methods: {
    loaded: function() {
      this.loading = false;
    },
    previousPage: function() {
      if(this.currentPage > 1) { this.currentPage-- }
    },
    nextPage: function() {
      if(this.currentPage < this.totalPages) { this.currentPage++ }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/pages/_var.scss';

.btn-circle {
  width: 40px;
  height: 40px;
  padding: 7px 10px;
  border-radius: 25px;
  font-size: 12px;
  text-align: center;
  background-color: $color-pink;
  border-color: $color-pink;

  &[disabled] {
    background-color: $color-primary;
    border-color: $color-primary;
  }
}
.pdf-container {
  margin: 1rem 0;
}
.loader {
  color: $color-pink;
  text-align: center;
  margin: 10rem 0rem;
}

@media (min-width: 768px) {
  .pdf-container {
    box-shadow: 0px 0px 10px #9b9b9b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/pdfViewer.vue